<script setup>
import MultiSelectComponent from "@/components/MultiSelectComponent.vue";
import useWindtagFilterOptions from "@/scripts/Devices/WindtagFilterOptions.js";
import { useStore } from "vuex";
import { onMounted } from "vue";

const store = useStore();

onMounted(() => {
  store.dispatch("devicesFilterOptions/fetchFilterOptions");
  store.commit("windtagDevices/RESET_DEVICE_QUERY");
  store.commit("devicesFilterOptions/RESET_FILTER_OPTIONS");
});

const {
  loading,
  course,
  primaryCourses,
  windtagDeviceClass,
  windtagDeviceClasses,
  filterDevices,
} = useWindtagFilterOptions();
</script>

<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <form>
              <div class="card-header">
                <h3 class="card-title">FILTERS OPTIONS:</h3>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Course Name</label>
                      <MultiSelectComponent
                        v-model="course"
                        :options="primaryCourses"
                        label="name"
                        track-by="id"
                        placeholder="Select Course"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Device Class</label>
                      <MultiSelectComponent
                        v-model="windtagDeviceClass"
                        :options="windtagDeviceClasses"
                        label="name"
                        track-by="id"
                        placeholder="Select Device Class"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <button
                        type="button"
                        class="btn btn-block btn-success"
                        @click="filterDevices()"
                        :disabled="loading"
                      >
                        <font-awesome-icon
                          v-show="loading"
                          :icon="['fas', 'spinner']"
                          spin
                        />
                        <span v-show="!loading">Filter Devices</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
